<template>
  <td
    v-if="statistic.show"
    :aria-label="statistic.ariaLabel"
    :class="theClass"
    :title="statistic.hoverTitle"
  >
    {{ statistic.footnote }}
    {{ statistic.formattedValue }}
    <!-- |{{statistic.xlsxValue}} -->
  </td>
</template>

<script>
/* eslint no-unused-vars: 'off' */
function getTheClass(statistic) {
  return (
    "statistic-value " +
    (statistic.isRowTotal !== null && statistic.isRowTotal
      ? "row-total"
      : "statistic-cell")
  );
}

// function getFootnote(statistic) {
//   if (statistic.noData)
//     return '**';
//   if (statistic.isSampleSizeIsTooLow || statistic.isRelativeStandardErrorTooHigh)
//     return '*';
//   if (statistic.isMissing)
//     return '-';
//   return '';
// }

// function getTitleClassAndValue(statistic, value, title, apiName, isRowTotal) {
//   if (statistic.value === undefined)
//     return {
//         theClass: ''
//     };

//   let theClass = getTheClass(statistic);
//   let footnote = getFootnote(statistic);

//   if (footnote === '' || footnote === '**')
//   return {
//       theClass,
//       theValue: '',
//       floatValue: statistic.floatValue
//     }

//   else
//     return {
//       theClass,
//       theValue: '',
//       floatValue: ''
//     }
// }

function getXlsxValue() {
  let vm = this;
  return vm.theValue;
}

export default {
  //props: ['statistic.value', 'definition', 'totalSourceRecords', 'isRowTotal'],
  props: ["statistic"],
  data: function () {
    let vm = this;
    return {
      theClass: getTheClass(vm.statistic),
    };
    //return getTitleClassAndValue(vm.statistic);
  },
  methods: {
    getXlsxValue,
  },
};
</script>

<style scoped>
div.statistic-row {
  padding: 0 4px 0 4px;
  white-space: nowrap;
}
td {
  padding: 0px 4px 0px 4px;
  text-align: center;
  width: 61px;
}
td.row-total {
  padding: 0px 4px 0px 10px;
  text-align: center;
}
td.statistic-old {
  /*display: inline-block;*/
  /*float: inline-block;*/
  /*float: left;*/
  /*margin-left: 10px;*/
  /*background-color: deepskyblue;*/
  /*background-color: ghostwhite;*/
  padding: 0 4px 0 4px;
  margin: 2px 4px 2px 4px;
  text-align: center;
}
</style>
